import EmployeesStatistics from "./components/EmployeesStatistics";
import EmployeesTable from "./components/EmployeesTable";

const EmployeesTab = () => {
  return (
    <div>
      <EmployeesStatistics />
      <EmployeesTable />
    </div>
  );
};

export default EmployeesTab;
